import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { PassengerCreationResponse } from '../Models/BookingPassengerTicketIssuanceProperties';
import { bookingInfoForONEG, ExchangeEligibility } from '../Models/TravelPortNewProperties';

@Injectable({
  providedIn: 'root'
})
export class TravelPortService {
  baseUrl = environment.baseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
  ModifyAutoRemoveBookingDate(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/TravelPort/ModifyAutoRemoveBookingDate', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  ModifyReservationEligibility(obj): Observable<ExchangeEligibility> {
    return this.http.post<ExchangeEligibility>(this.baseUrl + '/TravelPort/ModifyReservationEligibility', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  GetUpdateableItemsOfPassenger(obj): Observable<bookingInfoForONEG> {
    return this.http.post<bookingInfoForONEG>(this.baseUrl + '/TravelPort/GetUpdateableItemsOfPassenger', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  UpdateThePassengerDetails(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/TravelPort/UpdateThePassengerDetails', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
}
